import { Box, Skeleton } from '@mui/material'
import custom from '../../styles/mui/szVariables.json'

export default function SkeletonCard({ height }: any) {
    return (
        <Box sx={{ height }}>
        <Skeleton variant="rectangular" 
                    height={height}
                    width="100%"
                    sx={{ 
                        borderRadius: custom.corners5
                    }}/>
        </Box>
    )
}